// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__25vYD","containerItemsCenter":"Skeleton_containerItemsCenter__cw420"};